// ADDING CONTENT

export const CE_ADD_NEW_CONTENT = "CE_ADD_NEW_CONTENT";
export const ceAddContent = (format, activeHtmlEditor) => {
  return {
    type: CE_ADD_NEW_CONTENT,
    format: format,
    active_html_editor: activeHtmlEditor,
  };
};

// DUPLICATING CONTENT

export const CE_DUPLICATE_CONTENT = "CE_DUPLICATE_CONTENT";
export const ceDuplicateContent = (clientContentID) => {
  return {
    type: CE_DUPLICATE_CONTENT,
    client_content_id: clientContentID,
  };
};
